import sinchService from '../../services/sinchService';
import {orderBy} from 'lodash';

const state = {
  assignedNumbers: [],
  configurations: [],
  contacts: [],
  conversations: [],
  templates: [],
}

const mutations = {
  setAssignedNumbers(state, assignedNumbers) {
    state.assignedNumbers = assignedNumbers;
  },
  setConfigurations(state, configurations) {
    state.configurations = orderBy(configurations, ['team_id', 'code'], ['asc', 'asc']);
  },
  setContacts(state, contacts) {
    state.contacts = orderBy(contacts, ['slug'], ['asc']);
  },
  setConversations(state, conversations) {
    state.conversations = conversations;
  },
  setTemplates(state, templates) {
    state.templates = templates;
  }
}

const getters = {
  assignedNumbers: state => state.assignedNumbers,
  configurations: state => state.configurations,
  contacts: state => state.contacts,
  conversations: state => state.conversations,
  templates: state => state.templates,
}

const actions = {
  async fetchAssignedNumbers({commit}) {
    const numbers = await sinchService.getAssignedNumbers();
    commit('setAssignedNumbers', numbers);
    return numbers;
  },
  async fetchConfigurations({commit}) {
    const configurations = await sinchService.getConfigurations();
    commit('setConfigurations', configurations);
    return configurations;
  },
  async fetchContacts({commit}) {
    const contacts = await sinchService.getContacts();
    commit('setContacts', contacts);
    return contacts;
  },
  async fetchConversations({commit}) {
    const conversations = await sinchService.getConversations();
    commit('setConversations', conversations);
    return conversations;
  },
  async fetchTemplates({commit}) {
    const templates = await sinchService.getTemplates();
    commit('setTemplates', templates);
    return templates;
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
